import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UITruncateString from 'UIComponents/text/UITruncateString'; //@ts-expect-error no types for this lib

import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
export const AttainmentBarName = ({
  email,
  name,
  avatarSize
}) => email ? /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(UIAvatar, {
    hubSpotUserEmail: email,
    size: avatarSize,
    displayName: name || email,
    textSpacing: 1
  }), /*#__PURE__*/_jsx(UITruncateString, {
    className: "m-left-3",
    children: name || email
  })]
}) : /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(UIIconCircle, {
    name: "lists",
    color: BATTLESHIP,
    backgroundColor: GYPSUM,
    borderWidth: 0,
    size: 8
  }), /*#__PURE__*/_jsx(UITruncateString, {
    className: "m-left-3",
    children: name
  })]
});